import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { ContainerPriveteRoute } from "./style";

export function PrivateRoute() {
  const cartSuccess = useSelector((state) => state.cartSuccess.data);

  if (cartSuccess === true) return <Outlet />;
  else
    return (
      <ContainerPriveteRoute>
        <h1>Ops</h1>
        <p>Desculpe, mas esta página não pode ser exibida no momento.</p>
      </ContainerPriveteRoute>
    );
}
